export enum KEY_ORDER {
  ASC = 'ASC',
  DESC = 'DESC',
}
